import React, { useState, useContext } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import Modal from '../../Modal';
import AuthForms from '../../AuthForms';
import styles from './ModalAuth.module.sass';
import cn from 'classnames';
import { ModalContext } from '../../../contexts/Modal/ModalContext';
import { AUTH_ZONE } from '../../AuthForms';
import Image from '../../Image';

const ModalAuth = ({ userData }) => {
    
    const { show, hide, setTitle } = useContext( ModalContext );

    const renderAuthForms = function(){
        return <AuthForms onFinishCallback={ hide } onAuthZoneChanged={onAuthZoneChanged}/>;
    }

    const onAuthZoneChanged = function( zoneType ){

        switch( zoneType ){
            case AUTH_ZONE.LOGIN: return setTitle( 'Login' );
            case AUTH_ZONE.EMAIL_VERIFICATION: return setTitle( 'Verify Email' );
            case AUTH_ZONE.PASSWORD_RESET: return setTitle( 'Reset Password' );
            case AUTH_ZONE.REGISTER: return setTitle( 'Register' );
        }
    
    }

    return (
        <>
            {!userData.isLogged && (
                <button
                    className={styles.actioner}
                    onClick={ () => { show( { content: renderAuthForms(), title: 'Login' } ); } }>
                        <Image src='/assets/icon_profile.png' srcDark='/assets/icon_profile.png'/>
                </button>
            )}
        </>
    );
};

export default ModalAuth;
